import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatList } from '@blocks-react/components/List';
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import cx from 'classnames';
import styles from '../VisionLink.module.scss';

type CatListProps = ComponentProps<typeof CatList>;

export const VisionLinkCards: FC<PropsWithChildren<CatListProps>> = ({
  children,
  className
}) => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  return (
    <CatList
      orientation="horizontal"
      behavior={isMD ? undefined : 'overflow'}
      shadow="subtle"
      className={styles['vision-link-cards']}
    >
      <div className={cx(`d-flex w-100 position-relative ${className}`)}>
        {children}
      </div>
    </CatList>
  );
};
